export default __webpack_public_path__ + "static/telepointers-light-46404ca14f4ee66cf38c00e21ecee9f50fef95c7924a76a5d082597f29e003f5.png";